import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money, shortDate, type EntrySummary } from "../api";
import { ErrorNotice, Loading } from "../ui";

export function Records() {
  const [entries, setEntries] = useState<EntrySummary[] | null>(null);
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    api.get<EntrySummary[]>("/api/entries?status=confirmed&limit=500").then(setEntries).catch(setError);
  }, []);
  return (
    <div className="stack" style={{ "--gap": "24px" } as React.CSSProperties}>
      <div>
        <h1>Records</h1>
        <p className="muted">Everything you've saved, newest first. Each one keeps its original document.</p>
      </div>
      <ErrorNotice error={error} />
      {!entries ? <Loading /> : entries.length === 0 ? (
        <div className="card flat empty">No saved records yet.</div>
      ) : (
        <div className="card list-card list">
          {entries.map((e) => (
            <Link key={e.id} to={`/inbox/${e.id}`} className="list-item">
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{e.supplier ?? e.description ?? "Entry"}</div>
                <div className="muted small">{shortDate(e.date)} · {e.categoryName}</div>
              </div>
              {e.autoConfirmed && <span className="pill ok" title="Saved automatically from a supplier you've filed the same way before">Auto</span>}
              <span className="amount">{money(e.amountCents)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
